'use client';

import * as React from 'react';

import { cn } from '@/lib/utils';

export interface ChartConfig {
  [key: string]: {
    label: string;
    color?: string;
  };
}

const ChartContainer = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & {
    config: ChartConfig;
  }
>(({ className, config: _config, children, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn('w-full', className)}
      style={
        {
          '--color-desktop': '#10b981',
          '--color-mobile': '#3b82f6',
          '--chart-1': '220 70% 50%',
          '--chart-2': '210 70% 50%',
          '--chart-3': '200 70% 50%',
          '--chart-4': '190 70% 50%',
          '--chart-5': '180 70% 50%',
          '--color-type-1': 'hsl(220, 70%, 50%)',
          '--color-type-2': 'hsl(210, 70%, 50%)',
          '--color-type-3': 'hsl(200, 70%, 50%)',
          '--color-type-4': 'hsl(190, 70%, 50%)',
          '--color-type-5': 'hsl(180, 70%, 50%)',
        } as React.CSSProperties
      }
      {...props}
    >
      {children}
    </div>
  );
});
ChartContainer.displayName = 'ChartContainer';

const ChartTooltip = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};

const ChartTooltipContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & {
    labelFormatter?: (value: any) => string;
    indicator?: 'dot' | 'line';
  }
>(
  (
    {
      className,
      labelFormatter: _labelFormatter,
      indicator: _indicator,
      ...props
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={cn(
          'rounded-lg border bg-background p-2 shadow-md',
          className
        )}
        {...props}
      />
    );
  }
);
ChartTooltipContent.displayName = 'ChartTooltipContent';

const ChartLegend = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};

const ChartLegendContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn('flex items-center justify-center gap-4 pt-4', className)}
      {...props}
    />
  );
});
ChartLegendContent.displayName = 'ChartLegendContent';

export {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  ChartLegend,
  ChartLegendContent,
};
